import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import CheckIcon from '@mui/icons-material/Check'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { isBoolean, map, reduce } from 'lodash'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { RecordListOrderOption } from '../../../../swagger/dto'

const DefaultFilters = [
    {
        title: 'По дате',
        value: RecordListOrderOption.CreatedAt,
    },
    {
        title: 'По названию',
        value: RecordListOrderOption.Title,
    },
]

const DescFilter = [
    {
        title: 'По возрастанию',
        value: false,
    },
    {
        title: 'По убыванию',
        value: true,
    },
]

interface FilterOption {
    value: string
    title: string
}

interface Props {
    filters?: FilterOption[]
    defaultFilter: string
}

export const DateFilter: React.FC<Props> = ({ filters = DefaultFilters, defaultFilter }) => {
    const [desc, setDesc] = useState(true)
    const [orderBy, setOrderBy] = useState(defaultFilter)
    const [searchParams, setSearchParams] = useSearchParams()

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const filtersConfig = reduce(
        filters,
        (acc, { value, title }) => ({ ...acc, [value]: title }),
        {},
    )

    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleChange = (value) => {
        if (isBoolean(value)) {
            setDesc(value)
        } else {
            setOrderBy(value)
        }
        setAnchorEl(null)
    }

    useEffect(() => {
        searchParams.set('order_by', orderBy)
        searchParams.set('desc', desc)
        setSearchParams(searchParams)
    }, [orderBy, desc])

    return (
        <Grid
            sx={{
                display: 'flex',
                minWidth: '154px',
            }}>
            <Button
                sx={{ color: '#5A5F72', padding: '10px 0' }}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="text"
                disableElevation
                onClick={handleClick}
                endIcon={<ArrowDropDownIcon />}>
                {desc === true ? (
                    <ArrowUpwardIcon sx={{ fontSize: '12px' }} />
                ) : (
                    <ArrowDownwardIcon sx={{ fontSize: '12px' }} />
                )}
                {filtersConfig[orderBy]}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {map(filters, (item) => {
                    return (
                        <MenuItem
                            key={item.value}
                            value={item.value}
                            onClick={() => handleChange(item.value)}
                            sx={{ pl: 3, background: item.value === orderBy ? '#F4F4F6' : '#fff' }}>
                            {item.value === orderBy ? (
                                <CheckIcon
                                    sx={{ fontSize: '12px', position: 'absolute', left: '8px' }}
                                />
                            ) : null}
                            {item.title}
                        </MenuItem>
                    )
                })}
                <Divider sx={{ borderColor: '#F4F4F6' }} />
                {map(DescFilter, (item) => {
                    return (
                        <MenuItem
                            key={`${item.value}`}
                            value={item.value}
                            onClick={() => handleChange(item.value)}
                            sx={{ pl: 3, background: item.value === desc ? '#F4F4F6' : '#fff' }}>
                            {item.value === desc ? (
                                <CheckIcon
                                    sx={{ fontSize: '12px', position: 'absolute', left: '8px' }}
                                />
                            ) : (
                                ''
                            )}
                            {item.title}
                        </MenuItem>
                    )
                })}
            </Menu>
        </Grid>
    )
}
